export default
{
	INVITED: 'invited',
	JOINED: 'joined'
};